document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ec-product-banner-slider__swiper').forEach(swiperEl => {
    const sectionId = swiperEl.dataset.swiperId;
    const wrapper = swiperEl.closest('.ec-product-banner-slider__wrapper');
    
    if (!wrapper) return;

    const prevButton = wrapper.querySelector(`[data-swiper-prev="${sectionId}"]`);
    const nextButton = wrapper.querySelector(`[data-swiper-next="${sectionId}"]`);

    new Swiper(swiperEl, {
      slidesPerView: 1.085,
      spaceBetween: 20,
      loop: false,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      }
    });
  });
});
